import { render, staticRenderFns } from "./JoaDocSendingFormOpt.vue?vue&type=template&id=b995e618&"
import script from "./JoaDocSendingFormOpt.vue?vue&type=script&lang=js&"
export * from "./JoaDocSendingFormOpt.vue?vue&type=script&lang=js&"
import style0 from "./JoaDocSendingFormOpt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports